import { registerLocaleData } from '@angular/common';
import localeFrCa from '@angular/common/locales/fr-CA';

registerLocaleData(localeFrCa, 'fr-CA');
